export default __webpack_public_path__ + "static/walkWithGradma-cc62f1fbe1e277d9092b847df9dcf3c3.webp";